import React, { useState } from "react";
import { Button, Form, Input } from "antd";
import { useNavigate } from "react-router";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useAuth } from "../../context/AuthContext";
import { Severty, ShowToast } from "../../helper/toast";

const Forgetpassword = () => {
  const [inputType, setInputType] = useState("email");
  const { forgetPassword, loading, setLoading, sentSMS } = useAuth();
  const onFinish = async (values) => {
    try {
      let data = {
        email: values.email,
      };
      // If phone number is selected, format the data properly
      if (inputType === "phone" && values.phone) {
        let phoneNumber = values.phone;
        let countryCode, number;

        if (phoneNumber.length == 12) {
          countryCode = phoneNumber.substring(0, 2);
          number = phoneNumber.substring(2);
        } else if (phoneNumber.length == 13) {
          countryCode = phoneNumber.substring(0, 3);
          number = phoneNumber.substring(3);
        } else if (phoneNumber.length == 11) {
          countryCode = phoneNumber.substring(0, 1);
          number = phoneNumber.substring(1);
        }
        data = {
          phone: number,
          countryCode: `+${countryCode}`,
        };
      }

      const result = await forgetPassword(data);
      if (result.status === 200) {
        setLoading(false);
        if (inputType === "email") {
          ShowToast(result.message, Severty.SUCCESS);
          Navigate("/otp", {
            state: {
              data:
                inputType === "phone"
                  ? { phone: data.phone, countryCode: data.countryCode }
                  : { email: values.email },
            },
          });
        } else {
          ShowToast(
            `${result.message} OTP - ${result.data.otp}`,
            Severty.SUCCESS
          );
          const smsData = {
            phone: data.phone,
            countryCode: data.countryCode,
            otp: result.data.otp,
          };
          await sentSMS(smsData);
          Navigate("/otp", {
            state: {
              data: { phone: data.phone, countryCode: data.countryCode },
            },
          });
        }
      } else {
        setLoading(false);
      }
    } catch (error) {
      console.error("Login error:", error);
      setLoading(false);
      ShowToast(error.message, Severty.ERROR);
    }
  };
  const Navigate = useNavigate();

  return (
    <div className="signup-container">
      <div className="signup-box">
        <h4 className="signup-title">Forget Password</h4>
        <p className="signup-subtitle">
          Enter your email or phone number to reset your password.
        </p>

        <Form layout="vertical" onFinish={onFinish} requiredMark={false}>
          <div className="social-buttons">
            <Button
              className={`social-btn social-btn-mainjj ${
                inputType === "email" ? "phone-login-active" : ""
              }`}
              onClick={() => setInputType("email")}
            >
              Email
            </Button>
            <Button
              className={`social-btn social-btn-mainjj ${
                inputType === "phone" ? "phone-login-active" : ""
              }`}
              onClick={() => setInputType("phone")}
            >
              Phone Number
            </Button>
          </div>

          {inputType === "email" ? (
            <Form.Item
              name="email"
              rules={[
                { required: true, message: "Please enter your email" },
                { type: "email", message: "Please enter a valid email" },
              ]}
              className="mb-5"
            >
              <Input className="signup-input" placeholder="Email" />
            </Form.Item>
          ) : (
            <Form.Item
              name="phone"
              rules={[
                { required: true, message: "Please enter your phone number" },
                {
                  validator: (_, value) => {
                    if (
                      !value ||
                      value.trim() === "" ||
                      value === "undefined"
                    ) {
                      return Promise.reject(
                        new Error("Phone number is required")
                      );
                    }

                    // ✅ Remove spaces and '+' and check if it's digits
                    const digits = value.replace(/\D/g, "");
                    if (digits.length < 8) {
                      return Promise.reject(
                        new Error("Please enter a valid phone number")
                      );
                    }

                    return Promise.resolve();
                  },
                },
              ]}
              className="main-new-height-mobile-input"
            >
              <PhoneInput
                country="kw"
                defaultCountry="kw"
                inputStyle={{
                  width: "100%",
                  height: "57px",
                  borderRadius: "12px",
                  background: "transparent",
                  color: "white",
                  border: "none",
                  fontSize: "16px",
                }}
                buttonStyle={{
                  background: "#54545469",
                  border: "none",
                  borderRadius: "12px 0 0 12px",
                  height: "57px",
                  color: "white",
                }}
                containerStyle={{
                  height: "57px",
                  borderRadius: "12px",
                  background: "#54545469",
                  border: "none",
                }}
                dropdownStyle={{
                  background: "#2a2a2a",
                  border: "1px solid #54545469",
                  borderRadius: "12px",
                  color: "white",
                }}
                searchStyle={{
                  background: "#2a2a2a",
                  color: "white",
                  border: "1px solid #54545469",
                  borderRadius: "8px",
                }}
                placeholder="Phone Number"
              />
            </Form.Item>
          )}

          <Form.Item>
            <Button
              className="Fill-button"
              htmlType="submit"
              loading={loading}
              disabled={loading}
            >
              Continue
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default Forgetpassword;
